module.exports = __webpack_public_path__ + "static/media/foto2.fe6350b9.png";